import { User } from './user';

export class AuthFields {
	constructor(
		public token?: string,
		public refreshToken?: string,
		public loggedInUser?: User,
	) {
		this.loggedInUser = loggedInUser ? new User(loggedInUser) : loggedInUser;
	}
}
